import React from 'react';
import { Text } from '../../atoms/Text/Text';
import { Avatar } from '../../molecules/Avatar';
import { SupportAttachmentList } from './SupportAttachmentList';
import { safeAvatarUrl } from './avatarUrl';
import { SUPPORT_COPY, SUPPORT_DEFAULT_AUTHOR_NAME } from '../../../features/AIChatWidget/constants/support';
import './AIHumanSupportMessageStyles.scss';
const baseClass = 'qmb-ui-ai-human-support-message';
/**
 * AIHumanSupportMessage Component
 * A message written by a human InspectPoint Support agent during a live chat. Left-aligned
 * and visibly distinct from both the customer's bubble and an IPA response, with the actual
 * author named so the customer always knows who they are talking to.
 * @version 1.0.0
 * @since 2026-10-27
 */
export function AIHumanSupportMessage({ authorName, message, attachments = [], resolveAttachmentUrl, authorAvatarUrl, unavailableAttachments = [], showAuthor = true }) {
    if (!message && attachments.length === 0 && unavailableAttachments.length === 0)
        return null;
    const displayName = (authorName === null || authorName === void 0 ? void 0 : authorName.trim()) || SUPPORT_DEFAULT_AUTHOR_NAME;
    const avatarSrc = safeAvatarUrl(authorAvatarUrl);
    return (React.createElement("div", { className: baseClass, "data-testid": "human-support-message" },
        showAuthor && (React.createElement("div", { className: `${baseClass}__author`, "data-testid": "support-author" },
            avatarSrc ? (React.createElement(Avatar, { src: avatarSrc, label: displayName, size: "24" })) : (React.createElement("span", { className: `${baseClass}__avatar-fallback`, "data-testid": "support-avatar-fallback", "aria-hidden": "true" },
                React.createElement("i", { className: "fa-light fa-headset" }))),
            React.createElement(Text, { variant: "x-small" }, displayName))),
        React.createElement(SupportAttachmentList, { attachments: attachments, resolveUrl: resolveAttachmentUrl }),
        unavailableAttachments.map((entry, index) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(Text, { key: `${entry.name}-${index}`, variant: "body", className: `${baseClass}__unavailable` }, SUPPORT_COPY.UNAVAILABLE_ATTACHMENT(entry.name, entry.reason)))),
        message && (React.createElement("div", { className: `${baseClass}__bubble` },
            React.createElement(Text, { variant: "body" }, message)))));
}
